import { Group, NakedButton, useBreakpoint, useTheme } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { useMatch, useResolvedPath } from 'react-router-dom';

type SubscriptionTabsProps = {
  onChangeTab: (tab: string) => void;
};

export const SubscriptionTabs = ({ onChangeTab }: SubscriptionTabsProps) => {
  const { formatMessage } = useMelioIntl();
  const theme = useTheme();
  const resolvedPathUrl = useResolvedPath('');
  const match = useMatch({ path: `${resolvedPathUrl.pathname}/:tab/*`, end: true });
  const activeTab = match?.params.tab;
  const { isExtraSmallScreen } = useBreakpoint();

  const tabsList = [
    {
      label: formatMessage('activities.subscription.wizard.tabs.plans'),
      name: 'plans',
    },
    {
      label: formatMessage('activities.subscription.wizard.tabs.checkout'),
      name: 'checkout',
    },
  ];

  const tabs = tabsList.map((tab) => {
    const buttonsProps = {
      color: activeTab === tab.name ? theme.colors.brand.main : theme.colors.neutral.darker,
      paddingTop: 4,
      paddingBottom: 4,
    };

    return (
      <NakedButton
        key={tab.label}
        label={tab.label}
        size={isExtraSmallScreen ? 'small' : 'medium'}
        onClick={() => onChangeTab(tab.name)}
        {...buttonsProps}
      />
    );
  });

  return (
    <Group spacing="m" data-testid="subscription-wizard-tabs">
      {tabs}
    </Group>
  );
};
